import Proxy from "./Proxy"

class ProductProxy extends Proxy {
  constructor(parameters = {}) {
    super("products", parameters)
  }
}

export default ProductProxy
